import { IAward, IHackathonResponse } from "api/hackathon";
import { getNativeCurrency } from "./web3/Chain";

export const currencyFormatter = (number: number, locale: string = "en-US") => {
  const currencyFractionDigits = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
    style: "currency",
    currency: "USD",
  }).resolvedOptions().maximumFractionDigits;

  return number.toLocaleString(locale, {
    maximumFractionDigits: currencyFractionDigits,
  });
};

export function isJsonString(str: any) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const getTotalPrize = (_data?: IHackathonResponse) => {
  const totalString = _data?.prizes?.total_prizes;
  const nativeCurrency = getNativeCurrency(_data?.prizes?.network);

  if (typeof totalString === "number") return totalString;
  if (totalString && isJsonString(totalString)) {
    let result = "";
    const prizeObj = JSON.parse(totalString);
    if (prizeObj["nativeToken"] && prizeObj["nativeToken"] !== 0) {
      result += `${prizeObj["nativeToken"]} ${nativeCurrency} + `;
    }
    if (prizeObj["token"]) {
      Object.keys(prizeObj["token"]).forEach((x) => {
        if (prizeObj["token"][x] !== 0) {
          result += `${prizeObj["token"][x]} ${x} + `;
        }
      });
    }

    delete prizeObj.token;
    delete prizeObj["nativeToken"];

    Object.keys(prizeObj).forEach((x) => {
      if (prizeObj[x] !== 0) {
        result += `${x}${prizeObj[x]} + `;
      }
    });

    if (result) return result.substring(0, result.length - 2);
  }
  return 0;
};

export const checkHavingCryptoPrice = (awards: IAward[]) => {
  return awards.findIndex(
    (award) =>
      award.prizeCurrency === "nativeToken" || award.prizeCurrency === "token"
  );
};

export const toFixed = (x: any) => {
  if (Math.abs(x) < 1.0) {
    const e = parseInt(x.toString().split("e-")[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = "0." + new Array(e).join("0") + x.toString().substring(2);
    }
  } else {
    let e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x;
};
